import { siteInfo } from '@/mocks/homeData';

export default function Hero() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center bg-background-50 overflow-hidden pt-[72px]"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-20 right-0 w-[600px] h-[600px] bg-primary-100/30 rounded-full blur-3xl" />
        <div className="absolute bottom-10 left-10 w-[400px] h-[400px] bg-accent-100/20 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 w-full max-w-[1440px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary-100/80 rounded-full mb-6">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse" />
              <span className="text-xs font-medium text-primary-700 whitespace-nowrap">
                实时更新中 · 海量黑料视频
              </span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight">
              {siteInfo.name}
              <span className="block text-primary-500 mt-2">全网黑料短视频聚合平台</span>
            </h1>

            <p className="mt-2 text-lg md:text-xl text-foreground-600 font-heading">
              {siteInfo.slogan}
            </p>

            <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              {siteInfo.intro}
            </p>

            <div className="mt-8 flex flex-wrap items-center justify-center lg:justify-start gap-6">
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-checkbox-circle-line text-primary-500 text-lg" />
                <span>{siteInfo.stat1}</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-checkbox-circle-line text-primary-500 text-lg" />
                <span>{siteInfo.stat2}</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-checkbox-circle-line text-primary-500 text-lg" />
                <span>{siteInfo.stat3}</span>
              </div>
            </div>

            <div className="mt-10 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#media"
                onClick={(e) => {
                  e.preventDefault();
                  handleScroll('#media');
                }}
                className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-lg transition-all duration-200 whitespace-nowrap text-center cursor-pointer"
              >
                立即观看黑料视频
                <i className="ri-arrow-right-line ml-2" />
              </a>
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  handleScroll('#index');
                }}
                className="w-full sm:w-auto px-8 py-3.5 text-base font-medium text-foreground-700 bg-background-100 hover:bg-background-200 border border-background-200/70 rounded-lg transition-all duration-200 whitespace-nowrap text-center cursor-pointer"
              >
                浏览专题合集
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[560px] lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-r from-primary-500/20 to-accent-500/20 rounded-2xl blur-2xl" />
              <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Dynamic%20collage%20of%20entertainment%20news%20and%20social%20media%20content%20on%20a%20dark%20dramatic%20background%2C%20red%20and%20amber%20accent%20lights%2C%20multiple%20overlapping%20video%20thumbnails%20and%20headlines%2C%20cinematic%20composition%2C%20breaking%20news%20aesthetic%2C%20modern%20digital%20media%20collage%20with%20warm%20tones&width=1120&height=840&seq=hero-main&orientation=landscape"
                  alt="91黑料视频 - 海量黑料短视频在线观看平台"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-3 -right-3 bg-background-50 rounded-xl px-4 py-3 flex items-center gap-3">
                <div className="w-10 h-10 bg-primary-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-fire-line text-primary-500 text-lg" />
                </div>
                <div>
                  <div className="text-xs text-foreground-500">今日更新</div>
                  <div className="text-lg font-bold text-foreground-900 font-heading">200+</div>
                </div>
              </div>
              <div className="absolute -top-3 -left-3 bg-background-50 rounded-xl px-4 py-3 flex items-center gap-3">
                <div className="w-10 h-10 bg-accent-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-play-circle-line text-accent-600 text-lg" />
                </div>
                <div>
                  <div className="text-xs text-foreground-500">累计视频</div>
                  <div className="text-lg font-bold text-foreground-900 font-heading">50万+</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:block">
        <a
          href="#media"
          onClick={(e) => {
            e.preventDefault();
            handleScroll('#media');
          }}
          className="flex flex-col items-center gap-1 text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer"
        >
          <span className="text-xs">向下滚动</span>
          <i className="ri-arrow-down-line text-lg animate-bounce" />
        </a>
      </div>
    </section>
  );
}